import { t } from "i18next";
import { z } from "zod";

/**
 * The schema for the template form.
 */
export const templateFormConfig = z.object({
    /** The name of the template. */
    name: z.string().min(1, { message: t("validation.required") }),
});

export type TemplateFormConfig = z.infer<typeof templateFormConfig>;
